/** Client-generated UUID v4. Used as the offline-sync idempotency key
 *  attached to every sale (§6 of module-1 doc). */
export function createLocalUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for older runtimes — RFC 4122 v4.
  const buf = new Uint8Array(16);
  const src =
    typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function' ? crypto : null;
  if (src) src.getRandomValues(buf);
  else for (let i = 0; i < 16; i++) buf[i] = Math.floor(Math.random() * 256);
  buf[6] = ((buf[6] ?? 0) & 0x0f) | 0x40;
  buf[8] = ((buf[8] ?? 0) & 0x3f) | 0x80;
  const hex: string[] = [];
  for (const b of buf) hex.push(b.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`;
}
